<p-dialog
	[header]="header"
	[visible]="visible"
	(visibleChange)="$event ? null : close()"
	[modal]="true"
	[closable]="!saving"
	[draggable]="false"
	[resizable]="false"
	appendTo="body"
	[style]="{ width: '40rem' }"
	[breakpoints]="{ '768px': '95vw' }"
>
	<span class="p-input-icon-left w-full mb-3">
		<i class="pi pi-search"></i>
		<input
			pInputText
			type="text"
			class="w-full"
			placeholder="Global Search"
			[value]="search"
			[disabled]="loading"
			(input)="onSearch($any($event.target).value)"
		/>
	</span>

	<app-skeleton-loader *ngIf="loading" [count]="4" />

	<p-table
		*ngIf="!loading"
		styleClass="standard-table"
		[value]="filteredRows"
		[(selection)]="selection"
		[dataKey]="idField"
		[rows]="10"
		[paginator]="filteredRows.length > 10"
		responsiveLayout="scroll"
	>
		<ng-template pTemplate="header">
			<tr>
				<th style="width: 3rem"><p-tableHeaderCheckbox [disabled]="saving" /></th>
				<th *ngFor="let col of columns" [pSortableColumn]="col.field">
					{{ col.header }} <p-sortIcon [field]="col.field" />
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-row>
			<tr>
				<td><p-tableCheckbox [value]="row" [disabled]="saving" /></td>
				<td *ngFor="let col of columns">{{ row[col.field] ?? '—' }}</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td [attr.colspan]="columns.length + 1" class="text-center text-color-secondary py-4">
					{{ search ? 'No results match your search.' : emptyMessage }}
				</td>
			</tr>
		</ng-template>
	</p-table>

	<ng-template pTemplate="footer">
		<div class="flex align-items-center justify-content-between gap-2">
			<span class="text-sm text-color-secondary">
				<ng-container *ngIf="selection.length">{{ selection.length }} selected</ng-container>
			</span>
			<div class="flex gap-2">
				<p-button
					label="Cancel"
					severity="secondary"
					[outlined]="true"
					[disabled]="saving"
					(onClick)="close()"
				/>
				<p-button
					label="Add"
					icon="pi pi-check"
					[loading]="saving"
					[disabled]="!selection.length"
					(onClick)="submit()"
				/>
			</div>
		</div>
	</ng-template>
</p-dialog>
